<template>
  <div class="layout">
    <el-container>
      <el-aside width="auto" ref="zuidingwwaa" style="background-color: #fff;height: 100vh;">
        <leftnav :isCollapse="isCollapse" :userinfo="userinfo" :routeractive="routeractive" :headerH="zuiding"
          :widthimg="zuidingww">
        </leftnav>
      </el-aside>
      <el-container>
        <el-header height="auto" ref="header">
          <div class="header" ref="zuidingaaa">
            <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="isCollapse = !isCollapse"></i>
            <div class="qiyename" v-if="userinfo">{{ userinfo.qiyename ? userinfo.qiyename : '' }}</div>
            <div class="headerright">
              <el-dropdown @command="outlogin">
                <!-- <img :src="imgUrl(userinfo ? userinfo.avatar : '')" alt=""> -->
                <div class="righticon">
                  <i class="el-icon-s-custom"></i>
                  <div>个人中心</div>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="admininfo">个人中心</el-dropdown-item>
                  <el-dropdown-item command="out">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <!-- <div class="tabs">
            <div :class="index == activeindex ? 'tabsitemactive tabsitem' : 'tabsitem'" v-for="(item, index) in tabbers"
              :key="index">
              <span @click="spikrouter(item.path, index)"> {{ item.name }} </span>
              <i @click="deleteTab(index)" class="el-icon-error" v-if="index > 0"></i>
            </div>
          </div> -->
          <el-tabs ref="tabs" v-model="routeractive" type="card" @tab-click="spik" @tab-remove="removeTab">
            <el-tab-pane v-for="(item, index) in tabbers" :closable="index > 0" :key="item.path" :label="item.name"
              :name="item.path">
            </el-tab-pane>
          </el-tabs>
        </el-header>
        <el-main>
          <appmain :headerH="headerHeight"></appmain>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import leftnav from './components/navbar.vue'
import appmain from './components/appmain.vue'
import { getUserInfoApi } from '@/Api/home';
import { outtokenApi } from '@/Api/login'


export default {
  name: 'LayoutView',
  components: {
    leftnav, appmain
  },
  // 监听路由改变积
  watch: {
    $route(to) {
      this.updateRouterActive(to);
    }

  },
  created() {
    this.getuserinfo()
    this.updateRouterActive(this.$route);
  },
  data() {
    return {
      asidewidth: '200px',
      isCollapse: false,
      headerHeight: 0,
      zuiding: 0,
      zuidingww: 0,
      tabbers: [{
        name: '首页',
        path: 'home'
      }],
      editableTabsValue: 0,
      routeractive: 'home',
      nowrouteractive: '',
      // 改变样式的索引
      activeindex: 0,
      userinfo: null,
    }
  },
  mounted() {
    this.getHeaderHeight();
  },
  methods: {
    // 获取用户信息
    async getuserinfo() {
      let res = await getUserInfoApi();
      if (res.code == 0) {
        localStorage.setItem('userInfo', JSON.stringify(res.data))
        this.userinfo = res.data;
      }
    },
    //退出登录
    outlogin(e) {
      if (this.$route.name === e) return

      if (e == 'admininfo') {
        this.$router.push('/admininfo');
      }
      if (e == 'out') {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await outtokenApi();
          if (res.code == 0) {
            // 确认退出登录
            this.$message.success(res.msg);
            localStorage.removeItem('token')
            localStorage.clear()
            this.$router.push('/login')
          }

        }).catch(() => {
          // 取消退出登录
        })
      }

    },
    removeTab(targetName) {
      const indexToRemove = this.tabbers.findIndex(tab => tab.path === targetName);
      const currentActiveIndex = this.tabbers.findIndex(tab => tab.path === this.routeractive);
      if (indexToRemove === -1) return;
      this.tabbers.splice(indexToRemove, 1);
      // 如果删除的是当前激活的 tab，则激活临近的 tab
      if (indexToRemove === currentActiveIndex) {
        // 如果删除的 tab 是最后一个，则激活前一个；否则激活后一个
        const newIndex = indexToRemove === this.tabbers.length ? indexToRemove - 1 : indexToRemove;
        const newPath = this.tabbers[newIndex]?.path;
        if (newPath) {
          this.$router.push(newPath); // 导航到新的路径
          this.activeindex = newIndex;
          this.routeractive = newPath;
        }
      }
    },
    spik(e) {
      if (this.$route.name === e.name) return
      this.$router.push(e.name)
    },
    updateRouterActive(to) {
      // console.log(to);
      this.routeractive = to.name;
      // 根据当前路由的name和path，找到对应的索引，并更新activeindex

      const exists = this.tabbers.some(tab => tab.name === to.meta.name);
      if (exists) {
        let index = this.tabbers.findIndex(tab => tab.path === to.name);
        this.activeindex = index === -1 ? 0 : index;
        return
      }
      this.tabbers.push({
        name: to.meta.name,
        path: to.name
      });
      let index = this.tabbers.findIndex(tab => tab.path === to.name);
      this.activeindex = index === -1 ? 0 : index;




    },
    // 路由跳转
    spikrouter(path, index) {
      console.log(path, index);
      if (this.routeractive === path) return

      this.$router.push(path)
      // 改变样式
      this.activeindex = index
    },
    // 获取header的高度
    getHeaderHeight() {
      this.$nextTick(() => {
        this.headerHeight = Number((this.$refs.header.$el.getBoundingClientRect().height).toFixed(1));
        this.zuiding = Number((this.$refs.zuidingaaa.offsetHeight).toFixed(1));
        this.zuidingww = Number((this.$refs.zuidingwwaa.$el.getBoundingClientRect().width).toFixed(1));

      })

    },
    deleteTab(index) {
      let newindex = this.activeindex
      this.tabbers.splice(index, 1);
      if (this.activeindex === index) {
        this.activeindex = index - 1;
        this.$router.push(this.tabbers[this.activeindex].path);
      } else {
        if (index > newindex) return
        this.activeindex = newindex - 1;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.layout ::v-deep {
  .el-tabs__header {
    margin: 0;
    border-bottom: 1px solid #e4e7ed;
  }

  .el-tabs__item {
    height: 40px;
    line-height: 40px;
    color: #666;
    transition: all 0.3s;

    &:hover {
      color: #2b88ff;
    }

    &.is-active {
      background-color: #2b88ff !important;
      color: #fff !important;

      &:hover {
        color: #fff;
      }
    }
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #fff;

  .qiyename {
    flex: 1;
    color: #333;
    padding-left: 20px;
  }

  .headerright {
    .righticon {
      text-align: center;
      font-size: 14px;

      .el-icon-s-custom {
        font-size: 20px;
      }
    }

    img {
      width: 35px;
      height: 35px;
      border-radius: 50%;
    }
  }

  .el-icon-s-fold,
  .el-icon-s-unfold {
    font-size: 25px;
    font-weight: 400;
  }
}

// 穿透el-main样式
.layout::v-deep .el-main {
  padding: 0;
}

// 穿透el-main样式
.layout::v-deep .el-header {
  padding: 0;
}

.tabs {
  display: flex;
  background-color: #fff;

  .tabsitem {
    padding: 14px 24px;
    background-color: #f5f5f5;
    color: #A6AAB2;
    font-size: 16px;
    white-space: nowrap;
  }

  .tabsitem:hover {
    cursor: pointer;


  }

  i:hover {
    color: #333;
  }

  .tabsitemactive {
    background-color: #2b88ff;
    color: #fff;
  }
}
</style>